import blob1 from '../../../assets/vibes-keys/blob1.svg';
import blob2 from '../../../assets/vibes-keys/blob2.svg';
import blob3 from '../../../assets/vibes-keys/blob3.svg';
import blob4 from '../../../assets/vibes-keys/blob4.svg';
import blob5 from '../../../assets/vibes-keys/blob5.svg';

export const KEY_BLOBS = [
  { letter: 'A', image: blob1, note: 'C4' },
  { letter: 'D', image: blob2, note: 'E4' },
  { letter: 'G', image: blob3, note: 'G4' },
  { letter: 'J', image: blob4, note: 'B4' },
  { letter: 'L', image: blob5, note: 'C5' },
];

const COMMON_ANIMATION_CLASS =
  'transition-opacity ease-in-ease-out invisible duration-3000 opacity-0 [.keyboard-group.show-all_&]:opacity-100 [.keyboard-group.show-all_&]:visible [.keyboard-group:not(.show-all)_&]:h-0';

const LETTER_TO_ANIMATION_CLASS: Record<string, string> = {
  A: `${COMMON_ANIMATION_CLASS} delay-[2s]`,
  D: `${COMMON_ANIMATION_CLASS} delay-[1s]`,
  G: '', // Since the G key is always shown, it doesn't need a class override.
  J: `${COMMON_ANIMATION_CLASS} delay-[1.5s]`,
  L: `${COMMON_ANIMATION_CLASS} delay-[2.5s]`,
};

/** Every key except G fades in once the user plays a note, which flips the body to `show-all`. */
export const TUTORIAL_KEYS = KEY_BLOBS.map((key) => ({
  ...key,
  classOverride: LETTER_TO_ANIMATION_CLASS[key.letter],
}));

export const TUTORIAL_BODY_CLASS = 'keyboard-group';
export const SHOW_ALL_BODY_CLASS = 'keyboard-group show-all gap-0';
